// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:991px){.block-content-two-columns_col{width:100%}.block-content-two-columns_col:first-child{margin-bottom:32px}}@media(min-width:992px){.block-content-two-columns_col:first-child{padding-right:32px}.block-content-two-columns_col:last-child{padding-left:32px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
